import { AppLabel, AppSpan, AppText, CustomContainer, FlexRow } from "src/style"
import { BsChatLeftText, BsStar, BsStarFill, BsStarHalf } from 'react-icons/bs';
import { BiTimeFive } from 'react-icons/bi'
import { HiOutlineChevronUp } from 'react-icons/hi';


export const StatisticsSummary: React.FC<any> = () => {
    return (
        <CustomContainer topMargin='2.5'>
            <FlexRow gap='2' className="statistics-summary-wrapper">
                <CustomContainer className='av-response-time'>
                    <AppLabel color='#000000' fontWeight='600'>Average response time</AppLabel>
                    <CustomContainer
                        height='9' borderColor='#E2E8F0' radius='0.4'padding='1'
                    >
                        <FlexRow justifyContent='space-between'>
                            <AppLabel textSize='1.02' color='#718096'>Across all platforms</AppLabel>
                            <BiTimeFive style={{color: '#A6B7D4', fontSize: '1.6rem'}} />
                        </FlexRow>
                        <AppText textSize='1.8' fontWeight='700' color='#000000'>1hr 30 mins</AppText>
                        <FlexRow alignItems='flex-start'>
                            <AppSpan color='#F16063' textSize='1.2' fontWeight='700'>30%</AppSpan>
                            <AppSpan color='#F16063' textSize='1.2' leftPadding='0.5' topMargin='-0.15'><HiOutlineChevronUp/></AppSpan>
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer className='av-response-time'>
                    <AppLabel color='#000000' fontWeight='600'>Customer satisfaction</AppLabel>
                    <CustomContainer
                        height='9' borderColor='#E2E8F0' radius='0.4' padding='1'
                    >
                        <FlexRow justifyContent='space-between'>
                            <AppLabel textSize='1.02' color='#718096'>Across all platforms</AppLabel>
                            <BsStar style={{color: '#A6B7D4', fontSize: '1.6rem'}} />
                        </FlexRow>
                        <FlexRow justifyContent='space-between'>
                            <FlexRow>
                                { 
                                    Array.from(Array(4).keys()).map((item: any, index: number) => {
                                        let color = index <= 3 ? '#FFC107' : '#fff'
                                        return (
                                            <BsStarFill style={{fontSize: '1.6rem', color, marginRight: '0.5rem'}} key={index} />
                                        )
                                    })
                                }
                                <BsStarHalf style={{fontSize: '1.6rem', color: '#FFC107', marginRight: '0.5rem'}} />
                            </FlexRow>
                            <AppText color='#000000' textSize='1.8' fontWeight='700'>4.5/5</AppText>
                        </FlexRow>
                        <FlexRow alignItems='flex-start'>
                            <AppSpan color='#4AAE8C' textSize='1.2' fontWeight='700'>10%</AppSpan>
                            <AppSpan color='#4AAE8C' textSize='1.2' leftPadding='0.5' topMargin='-0.15'><HiOutlineChevronUp/></AppSpan>
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer className='statistics-comments'>
                    <AppLabel color='#000000' fontWeight='600'>Comments</AppLabel>
                    <CustomContainer
                        height='9' borderColor='#E2E8F0' radius='0.4' padding='1'
                    >
                        <FlexRow justifyContent='space-between'>
                            <AppLabel textSize='1.02' color='#718096'>Across all platforms</AppLabel>
                            <BsChatLeftText style={{color: '#A6B7D4', fontSize: '1.6rem'}} />
                        </FlexRow>
                        <FlexRow topMargin="1">
                            <CustomContainer width="46" sizeUnit="%">
                                <FlexRow justifyContent="space-between">
                                    <AppLabel color="#718096" textSize="1">Positive</AppLabel>
                                    <AppSpan textSize="1.2" fontWeight="600" topMargin="-0.2">5,000</AppSpan>
                                </FlexRow>
                                <CustomContainer bgColor="#EDF2F7" radius="5">
                                    <CustomContainer height="0.6" bgColor="#4AAE8C" width="80" sizeUnit="%"/>
                                </CustomContainer>
                            </CustomContainer>
                            <CustomContainer width="46" sizeUnit="%" leftMargin="2">
                                <FlexRow justifyContent="space-between">
                                    <AppLabel color="#718096" textSize="1">Negative</AppLabel>
                                    <AppSpan textSize="1.2" fontWeight="600" topMargin="-0.2">1,000</AppSpan>
                                </FlexRow>
                                <CustomContainer bgColor="#EDF2F7" radius="5">
                                    <CustomContainer height="0.6" bgColor="#F16063" width="80" sizeUnit="%"/>
                                </CustomContainer>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
            </FlexRow>
        </CustomContainer>
    )
}